import { memo } from 'react'
import { LuPencil } from 'react-icons/lu'

import { Badge, BadgeVariant } from '@/lib/core/components/Badge'
import { Truncate } from '@/lib/core/components/Truncate'

import { TagItemProps } from './TagsPopout.types'
import styles from './TagsPopout.module.css'

export const TagItem = memo<TagItemProps>(
  ({ tag, isSelected, isTagsUpdating, disabled = false, onToggle, onEdit }) => {
    return (
      <div className={styles.tagItem} onClick={(e) => e.stopPropagation()} data-testid="tag-item">
        <div className={styles.leftSide}>
          <div className={styles.tagCheckbox}>
            <input
              type="checkbox"
              id={`tag-${tag.id}`}
              checked={isSelected}
              onChange={(e) => {
                e.stopPropagation()
                onToggle(tag.id, e.target.checked, tag)
              }}
              disabled={isTagsUpdating || disabled}
              data-testid="tag-checkbox"
            />
            <label
              htmlFor={`tag-${tag.id}`}
              className={styles.checkboxLabel}
              style={{
                backgroundColor: isSelected ? '#314663' : 'transparent',
                borderColor: isSelected ? '#314663' : '#ccc',
                opacity: isTagsUpdating || disabled ? 0.7 : 1,
                cursor: isTagsUpdating ? 'wait' : disabled ? 'not-allowed' : 'pointer',
              }}
              onClick={(e) => e.stopPropagation()}
              data-testid="tag-checkbox-label"
            >
              {isSelected && <span className={styles.checkmark}>✓</span>}
            </label>
          </div>
          <Badge
            variant={BadgeVariant.TAG}
            backgroundColor={tag.color}
            minSize={20}
            onClick={(e) => e.stopPropagation()}
          >
            <Truncate content={tag.name} limit={15} />
          </Badge>
        </div>
        <button
          className={styles.editButton}
          onClick={(e) => {
            e.stopPropagation()
            onEdit?.(tag)
          }}
          disabled={isTagsUpdating}
          title="Edit tag"
          aria-label="Edit tag"
          data-testid="edit-button"
        >
          <LuPencil size={16} />
        </button>
      </div>
    )
  },
  (prevProps, nextProps) => {
    // Only re-render if these props change
    return (
      prevProps.tag.id === nextProps.tag.id &&
      prevProps.isSelected === nextProps.isSelected &&
      prevProps.isTagsUpdating === nextProps.isTagsUpdating
    )
  },
)

TagItem.displayName = 'TagItem'
